module.exports = __webpack_public_path__ + "img/bafang.849d5ea5.png";